import { ResponsiveFunnel } from '@nivo/funnel';

const funnelData = [
  { id: 'step_sent', value: 12345, label: 'Website Visit' },
  { id: 'step_viewed', value: 9876, label: 'Viewed Product' },
  { id: 'step_clicked', value: 7654, label: 'Added to Cart' },
  { id: 'step_add_to_card', value: 4567, label: 'Started Checkout' },
  { id: 'step_purchased', value: 2345, label: 'Purchased' },
];

export const AcquisitionFunnelChart = () => (
  <div style={{ height: '300px' }}>
    <ResponsiveFunnel
      afterSeparatorLength={100}
      afterSeparatorOffset={20}
      beforeSeparatorLength={100}
      beforeSeparatorOffset={20}
      borderWidth={20}
      colors={{ scheme: 'spectral' }}
      currentBorderWidth={40}
      currentPartSizeExtension={10}
      data={funnelData}
      labelColor={{ from: 'color', modifiers: [['darker', 3]] }}
      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      motionConfig="wobbly"
      shapeBlending={0.35}
      valueFormat=">-.4s"
    />
  </div>
);